module.exports = __webpack_public_path__ + "static/media/8-1.50e37c85.mp3";